import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import {Signals} from "@/Imports";
import ScaleManager from "@/stage/ScaleManager";
import {Spine} from "pixi-spine";
import Facade from "@/Facade";

/*
      VPFreezedStatic
      VPFreezing
      VPUnFreezing
 */

export default class FreezingContainer extends BaseContainer {
  constructor() {
    super()

    this.spine = new SpineAnimation('freezing')
    this.spine.scale.set(1)
    this.addChild(this.spine)

    this.isFreezing = false;

    this.delayID = 0

    const startFreeze = () => {
      this.isFreezing = true
      this.spine.start(['VPFreezing', 'VPFreezedStatic'], [false, false])
      Facade.soundManager.play('gameFreezeSound', 0.5)
    }

    const stopFreeze = () => {
      clearTimeout(this.delayID)
      if (this.isFreezing) {
        this.isFreezing = false
        this.spine.start(['VPUnFrezzing'], [false])
      }
    }

    Signals.startFeature.add(() => {
      this.delayID = setTimeout(startFreeze, Facade.model.randomTime)
    })
    Signals.stopFeature.add(stopFreeze)
    Signals.roundEnd.add(stopFreeze)
  }

}
